
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $lyoVb = parcelRequire("lyoVb");
function $840b47870f26e1a2$export$de27182ff8187d6c() {
    (0, $lyoVb.setupCommon)();
    textSize((0, $lyoVb.w)(0.05));
}
let $840b47870f26e1a2$var$x1 = 0.0;
let $840b47870f26e1a2$var$x2 = 3.2;
let $840b47870f26e1a2$var$x3 = 4.5;
let $840b47870f26e1a2$var$x4 = 1.9;
function $840b47870f26e1a2$export$e529deb2bfd496dc() {
    (0, $lyoVb.drawCommon)();
    background(100);
    stroke(0, 0, 0, 0.05);
    noFill();
    $840b47870f26e1a2$var$x1 = $840b47870f26e1a2$var$x1 + 0.001;
    $840b47870f26e1a2$var$x2 = $840b47870f26e1a2$var$x2 + 0.002;
    $840b47870f26e1a2$var$x3 = $840b47870f26e1a2$var$x3 + 0.001;
    $840b47870f26e1a2$var$x4 = $840b47870f26e1a2$var$x4 + 0.002 - $840b47870f26e1a2$var$x1 * 0.01;
    for(let i = 0; i < 450; i++){
        const n = noise($840b47870f26e1a2$var$x1, (0, $lyoVb.frameN) * 0.1, i * 0.001) * 1.0;
        line((0, $lyoVb.w)(n), 0, (0, $lyoVb.w)(n), (0, $lyoVb.h)(1));
    }
    for(let i = 0; i < 250; i++){
        const n = noise($840b47870f26e1a2$var$x2, (0, $lyoVb.frameN) * 0.1, i * 0.003) * 0.5 + 0.3;
        line((0, $lyoVb.w)(n), 0, (0, $lyoVb.w)(n), (0, $lyoVb.h)(1));
    }
    for(let i = 0; i < 450; i++){
        const n = noise($840b47870f26e1a2$var$x3, (0, $lyoVb.frameN) * 0.1, i * 0.001) + 0.3;
        line((0, $lyoVb.w)(n), 0, (0, $lyoVb.w)(n), (0, $lyoVb.h)(1));
    }
    for(let i = 0; i < 350; i++){
        const n = noise($840b47870f26e1a2$var$x4, (0, $lyoVb.frameN) * 0.1, i * 0.005) - 0.2;
        line((0, $lyoVb.w)(n), 0, (0, $lyoVb.w)(n), (0, $lyoVb.h)(1));
    }
    noStroke();
    fill(0, 0, 100);
    for(let i = 0; i < 10; i++){
        const n = i / 10;
        let ht = n > 0.5 ? (0, $lyoVb.easeInOutSine)(n * 2) : (0, $lyoVb.easeInOutSine)(n * 2 - 0.5);
        ht = ht * (0.4 + 0.4 * Math.sin(Math.PI * 2 * (0, $lyoVb.frameN) * 0.1));
        rect(0, (0, $lyoVb.h)(n), (0, $lyoVb.w)(1), (0, $lyoVb.h)(lerp(ht * 0.1, (0, $lyoVb.easeInOutSine)((0, $lyoVb.frameN)) * 1 / 10, (0, $lyoVb.frameN))));
    }
    fill(0, 0, 0, 10);
    if (noise((0, $lyoVb.frameN) * 20) > 0.5) text("THIS TOOK MORE", (0, $lyoVb.w)(0.5), (0, $lyoVb.h)(0.35));
    if (noise((0, $lyoVb.frameN) * 20, 0.42) > 0.5) text("THAN 10 MINUTES", (0, $lyoVb.w)(0.5), (0, $lyoVb.h)(0.65));
}



var $gPx2I = parcelRequire("gPx2I");
parcelRequire("d3dEA");
const $769c57de0b90302c$var$source = 'import {\n  easeInOutSine,\n  smoothstep,\n  clamp,\n  w, h,\n  frameN,\n  getCanvasSize,\n  setupCommon,\n  drawCommon,\n  make,\n} from \'../js/common.js\';\n\nexport function setup() {\n	setupCommon();\n	textSize(w(0.05));\n}\n\nlet x1 = 0.0;\nlet x2 = 3.2;\nlet x3 = 4.5;\nlet x4 = 1.9;\n\nexport function draw() {\n	drawCommon();\n\n	background(100);\n	stroke(0, 0, 0, 0.05);\n	noFill();\n\n	x1 = x1 + 0.001;\n	x2 = x2 + 0.002;\n	x3 = x3 + 0.001;\n	x4 = x4 + 0.002 - x1 * 0.01;\n\n	for (let i = 0; i < 450; i++) {\n		const n = noise(x1, frameN * 0.1, i * 0.001) * 1.0;\n		line(w(n), 0, w(n), h(1));\n	}\n\n	for (let i = 0; i < 250; i++) {\n		const n = noise(x2, frameN * 0.1, i * 0.003) * 0.5 + 0.3;\n		line(w(n), 0, w(n), h(1));\n	}\n\n	for (let i = 0; i < 450; i++) {\n		const n = noise(x3, frameN * 0.1, i * 0.001) + 0.3;\n		line(w(n), 0, w(n), h(1));\n	}\n\n	for (let i = 0; i < 350; i++) {\n		const n = noise(x4, frameN * 0.1, i * 0.005) - 0.2;\n		line(w(n), 0, w(n), h(1));\n	}\n\n	noStroke();\n	fill(0, 0, 100);\n	for (let i = 0; i < 10; i++) {\n\n		const n = i / 10\n		let ht = n > 0.5 ? easeInOutSine(n * 2) : easeInOutSine(n * 2 - 0.5);\n		ht = ht * (0.4 + 0.4 * Math.sin(Math.PI * 2 * frameN * 0.1));\n\n		rect(0, h(n), w(1), h(lerp(ht * 0.1, easeInOutSine(frameN) * 1 / 10, frameN)));\n	}\n\n	fill(0, 0, 0, 10);\n	if (noise(frameN * 20) > 0.5)\n		text("THIS TOOK MORE", w(0.5), h(0.35));\n	if (noise(frameN * 20, 0.42) > 0.5)\n		text("THAN 10 MINUTES", w(0.5), h(0.65));\n}\n';
(0, $gPx2I.make)({
    setup: $840b47870f26e1a2$export$de27182ff8187d6c,
    draw: $840b47870f26e1a2$export$e529deb2bfd496dc
}, $769c57de0b90302c$var$source);


//# sourceMappingURL=02.b25f4f2a.js.map
